import {TableCell, TableRow} from 'common/components/data-table/types';
import {SegmentId} from 'common/report/funnels/models/types';
import {CalendarDateRange} from 'common/widgets/date-range-picker/models/types';

export enum StatSigDisplayStatusColor {
  Green = `$stat-sig-green`,
  Red = `$stat-sig-red`,
}

export type StatSigDisplay = {
  /** Confidence that the variation in the segment's conversion rate is not driven by random chance */
  confidence: string;
  /** mp-color representing the interestingness */
  status?: StatSigDisplayStatusColor;
  /** string label to use in the UI */
  label?: string;
};

export interface FunnelTableRow extends TableRow<TableCell> {
  /** raw segment names (used as an array for multi seg) */
  props: SegmentId[];
  /** raw segment name */
  prop: string;
  /** overall conversion ratio for the segment */
  overall: number;
  /** Information needed for rendering a table row */
  displayInfo: {
    /** Conversion time statistics between Funnel steps */
    averageTimeBetweenSteps: number[];
    /** Raw conversion counts for each Funnel step */
    steps: Array<{count: number; conversionRatio: number}>;
  };
  isSelected: boolean;
  checkedColor?: string;
  isControlGroup?: boolean;
  /** Information needed for rendering the statistical significance of each segment */
  statSig?: StatSigDisplay;
}

export enum BarType {
  CONVERTED = `converted`,
  DROP_OFF = `drop-off`,
}

export interface SelectedBar {
  /* index of step */
  index: number;
  /* color of the bar */
  color: string;
  /* index of bar in step */
  barIdx: number;
  /* for time comparison value comparison selected */
  isComparison: boolean;
  /* the comparison time range */
  comparisonDateRange: CalendarDateRange | null;
  /* type of bar */
  type: BarType;
}

export interface BarData {
  /* conversion to the next step in its respective funnel between 0 - 1 */
  conversionToNext: number;
  /* conversion from the last step in its respective funnel between 0 - 1 */
  conversionRate: number;
  /* count of the bar */
  value: number;
  /* color used to override default color scheme */
  color?: string;
  /* name of the segment represented by the bar (when compare funnels is used) */
  segmentName?: string;
  /* same as segmentName :( */
  title?: string;
}

export interface Step {
  /* the data for the bars to be displayed in this step */
  data: BarData[];
  /* specifies if a step should render an empty column */
  empty?: boolean;
  /* sources name of the step */
  event?: string;
  color?: string;
  subheader?: string;
  title: string;
  tooltipText: string;
}
